import { Type, Static } from '@sinclair/typebox';
import { EmailSchema } from './email.schema';

/** */
export const EmailMetaSchema = Type.Intersect([
  Type.Pick(EmailSchema, ['id', 'thread_id', 'folders', 'message_id', 'subject', 'from', 'to', 'cc', 'bcc']),
  Type.Object({ body_plain_text: Type.String(), date: Type.Number() }),
]);

export type EmailMeta = Static<typeof EmailMetaSchema>;
